import React from "react";
import { motion } from "framer-motion";
import { CreditCard, Calculator, ShieldCheck, Banknote, ArrowRight } from "lucide-react";

const steps = [
  {
    Icon: CreditCard,
    label: "1. Select your gift card",
    desc: "Choose from 45+ trusted brands across US, UK, UAE & Canada.",
  },
  {
    Icon: Calculator,
    label: "2. See instant payout",
    desc: "Lock your guaranteed rate in seconds — no surprises, ever.",
  },
  {
    Icon: ShieldCheck,
    label: "3. Submit securely",
    desc: "256-bit encryption + AI fraud detection protect every trade.",
  },
  {
    Icon: Banknote,
    label: "4. Get paid in hours",
    desc: "Most cards are paid within 60 minutes to 24 hours via PayPal, Crypto or Bank.",
  },
];

export default function HowItWorks() {
  return (
    <section className="py-24 bg-white" data-testid="how-it-works">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <p className="text-xs uppercase tracking-[0.2em] text-[#00C853] font-semibold">How It Works</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0B3C5D] mt-3 tracking-tight">
            Four steps. No friction. Real money.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 relative">
          {steps.map(({ Icon, label, desc }, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="relative rounded-2xl border border-slate-200 bg-white p-6 card-hover"
              data-testid={`hiw-step-${i + 1}`}
            >
              <div className="w-12 h-12 rounded-xl bg-[#00C853]/10 flex items-center justify-center">
                <Icon className="w-6 h-6 text-[#00C853]" strokeWidth={2.2} />
              </div>
              <h3 className="font-display text-lg font-bold text-[#0B3C5D] mt-4">{label}</h3>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">{desc}</p>
              {i < steps.length - 1 && (
                <ArrowRight className="hidden lg:block absolute top-1/2 -right-4 -translate-y-1/2 w-5 h-5 text-slate-300" />
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
